<template>
  <div
    class="dropzone"
    @click="onClick"
    @dragenter.prevent="onDragEnter"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @dragend="onDragLeave"
    @drop.prevent="onDrop"
  >
    <input type="file" class="d-none" @change="onSelect" ref="file" />
    <slot>
      <img :src="value" class="img-fluid" v-if="value" />
    </slot>
    <b-modal
      centered
      body-class="text-center"
      footer-class="justify-content-center"
      hide-header
      ok-only
      ref="size"
    >
      <p>
        이미지당 용량이 10MB를 넘을 수 없습니다.<br />
        용량을 조절한 후 다시 시도해주세요.
      </p>
      <p>
        You can not upload images larger than 10MB.<br />
        Reduce file size and try again.
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      file: null
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
      if (event.cancelBubble) {
        return;
      }

      this.$refs.file.click();
    },
    onSelect(event) {
      const file = event.target.files[0];
      event.target.value = "";
      this.open(file);
    },
    onDrop(event) {
      event.target.classList.remove("hover");

      const file = event.dataTransfer.files[0];
      this.open(file);
    },
    onDragEnter(event) {
      event.target.classList.add("hover");
    },
    onDragOver(event) {
      event.dataTransfer.dropEffect = "copy";
    },
    onDragLeave(event) {
      event.target.classList.remove("hover");
    },
    open(file) {
      if (!file) {
        return;
      }

      if (file.size > 10485760) {
        this.$refs.size.show();
        return;
      }

      this.file = file;
      this.$emit("input", URL.createObjectURL(file));
    }
  }
};
</script>

<style lang="scss" scoped>
.dropzone {
  cursor: copy;
}

.hover {
  transition: all 0.5s;
  opacity: 0.3;
}
</style>
